<template>
  <v-app-bar clipped-left color="background" elevation="0" class="px-0 sticky">
    <nav-drawer-trigger class="mr-2"></nav-drawer-trigger>

    <v-toolbar-title v-if="!(isPadBool && searchexpanded)">
      <Breadcrumbs />
      <component :is="titleComponent" :title="titleOveride" :icon="iconOveride">
      </component>
    </v-toolbar-title>

    <v-spacer />

    <v-spacer v-if="!isPadBool && searchexpanded" />
    <HeaderBtns :collapsed="searchexpanded" />
    <v-btn v-if="searchexpanded && !isPadBool" icon @click="() => { blurtrigger++ }">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <v-card class=" mr-n4 my-n1 px-4 rounded-0 d-flex align-center" :class="isPhoneBool ? 'ml-0' : 'ml-3'"
      style="background-color: var(--v-navigationdrawer-base); box-shadow: inset 0 0 5px var(--v-header-darken2) !important;"
      height="calc(100% + 9px)" flat @click="focustrigger++">
      <GlobalSearch :blurtrigger="blurtrigger" :focustrigger="focustrigger" @WidthChange="e => (searchexpanded = e)" />
    </v-card>
    <template v-slot:extension v-if="showSubmenu">
      <v-tabs v-model="activeTab" height="47" class="y-outline">
        <template v-for="(item, index) in submenuItems">
          <SubMenuTab :hide="!(index < cutoff)" :key="item.name" :node="item"></SubMenuTab>
        </template>
        <!-- dropdown on smaller devices -->
        <v-menu v-if="submenuItems.length > cutoff" bottom offsetY z-index="20">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="align-self-center mr-4" v-bind="attrs" v-on="on">
              {{ isPhoneBool ? 'Tabs' : 'More' }}
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-tabs v-model="activeTab" vertical>
            <template v-for="(item) in submenuItems">
              <SubMenuTab :key="item.name" :node="item"></SubMenuTab>
            </template>
          </v-tabs>
        </v-menu>
      </v-tabs>
    </template>
  </v-app-bar>
</template>


<script>
import NavDrawerTrigger from "@/components/Buttons/NavDrawerTrigger.vue";
import Breadcrumbs from "@/components/Sections/AppSections/Breadcrumbs.vue";
import GlobalSearch from "@/components/Sections/AppSections/GlobalSearch.vue";
import HeaderBtns from "@/components/Sections/AppSections/HeaderBtns.vue";
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import SubMenuTab from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_Base.vue";
import NavMixin from "@/helpers/Mixins/NavMixin.js";

export default {
  name: "PageHeader",
  components: {
    NavDrawerTrigger,
    HeaderBtns,
    GlobalSearch,
    SubMenuTab,
    Breadcrumbs,
    Title_Base,
  },
  mixins: [NavMixin],

  data() {
    return {
      node: null,
      activeTab: 0,
      blurtrigger: 1,
      focustrigger: 0,
      searchexpanded: false,
    };
  },

  mounted() {
    this.headerHasSubmenu = !!this.showSubmenu;
  },

  methods: {
    goTo(routeName) {
      if (this.$route.name != routeName) {
        var routeCopy = Object.assign({}, this.$route);
        routeCopy.name = routeName;
        this.$router.replace(routeCopy);
      }
    },

    search() {
      var obj = Object.assign({}, this.$route.query);
      if (this.$store.state.globalSearchQuery == this.$route.query.q) {
        return;
      } else if (this.$store.state.globalSearchQuery !== "") {
        obj.q = this.$store.state.globalSearchQuery;
        this.$router.replace({ query: obj });
      } else {
        obj.q = undefined;
        this.$router.replace({ query: obj });
      }
    },

    isHeaderCardComponent(testnode) {
      return (
        testnode &&
        testnode.component &&
        testnode.component.name &&
        testnode.component.name === "HeaderCardsContainer" &&
        testnode.name != "Home"
      );
    },

    parseName(node) {
      var baseName = node.meta?.display ?? node.name;
      //console.log('parseName', node, baseName);
      /*
      if (typeof baseName === "object" && baseName.store) {
        return this.$store.getters[baseName.getter];
      }
      else*/ if (typeof baseName === "object" && baseName.key) {
        return this.$t(baseName.key, { okey: this.$t(baseName.okey) })
      }
      else {
        return baseName ?? 'Unknown page';
      }
    },
  },

  computed: {
    headerRoute() {
      var cr = this.$route;
      var parent = cr.matched.at(-2);
      //console.log('cr', cr, 'parent', parent);
      if (parent && (this.isHeaderCardComponent(cr) || parent?.meta?.contextMenu)) {
        //for special cases with nested context menus where you want to use the highest level context menu, iterate through the parents until you find one with a context menu
        if (parent?.meta?.contextMenu == "Inherit") {
          for (let index = 2; index < cr.matched.length; index++) {
            const element = cr.matched.at(-index);
            if (element.meta?.contextMenu == true) {
              parent = element;
              break;
            }
          }
        }
        return parent;
      }
      else {
        return cr;
      }
    },

    titleComponent() {
      //console.log('titleComponent', this.headerRoute);
      return this.headerRoute.meta?.overrides?.title || "Title_Base";
    },

    titleOveride() {
      return this.parseName(this.headerRoute)
    },

    iconOveride() {
      return this.headerRoute.meta?.icon ?? "mdi-alert";
    },

    hasSubMenu() {
      return this.headerRoute.meta?.contextMenu;
    },

    submenuItems() {
      var siblings = [];
      if (this.hasSubMenu) {
        const parentName = this.headerRoute.name;
        const routes = this.$router.getRoutes();
        siblings = routes.filter((x) => (
          x.parent?.name == parentName &&
          this.checkIfLicencedByKey(x.meta.licenceEnabled) &&
          this.checkIfFeatureEnabledByKey(x.meta.featureEnabled)
        ));
      }
      return siblings;
    },

    showSubmenu() {
      //console.log('showSubmenu', this.hasSubMenu, !!this.submenuItems[0], this.headerRoute.meta?.contextMenu);
      return this.hasSubMenu && !!this.submenuItems[0] && this.headerRoute.meta?.contextMenu != "Hidden";
    },

    cutoff() {
      var num = this.$vuetify.breakpoint.width / 100 - 3;
      return num;
    },
  },

  watch: {
    showSubmenu: function (val) {
      this.headerHasSubmenu = !!val;
    },
  },
};
</script>

<style lang="scss">
.v-toolbar__title {
  font-size: unset;
}

.v-toolbar__content,
.y-outline {
  border-bottom: 1px solid rgb(228, 228, 228);
  margin: 0px !important;
}

.v-toolbar__extension {
  padding: 0px !important;
}

.sticky {
  position: sticky;
}

@media only screen and (max-width: 1400px) and (min-width: 1000px) {
  .smallerheader2 {
    font-size: 1.2em;
  }
}
</style>